import Modal from "components/ui/Modal";
import styled from "styled-components";
import BackgroundImg from "./@image/chart-background.png";

const ModalHeader = styled.div`
  position: relative;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 16px;
  right: 20px;
  background: transparent;
  border: none;
  color: white;
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
`;

const HeaderContent = styled.div`
  position: relative;
  padding: 38px 24px 28px;
  background: linear-gradient(150.51deg, #0f2859 19.98%, #0046d2 70.69%);

  & > img {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 154px;
    height: 154px;
  }
`;

const ServiceTag = styled.div`
  background: linear-gradient(
    90deg,
    rgba(92, 54, 255, 0.6) 0%,
    rgba(24, 140, 255, 0.6) 100%
  );
  color: white;
  width: max-content;
  height: 30px;
  padding: 0 12px;
  border-radius: 8px;
  display: inline-block;
  font-size: 14px;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const HeaderTitle = styled.h2`
  color: white;
  font-size: 24px;
  font-weight: 700;
  line-height: 34px;
  letter-spacing: -0.4px;
  margin: 0;
`;

const ModalContent = styled.div`
  background: white;
  padding: 20px 24px 24px;
`;

const ContentText = styled.p`
  color: #70747d;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.2px;
  font-weight: 500;
  margin: 0 0 32px 0;
  padding-right: 16px;
`;

const HighlightText = styled.span`
  color: #003fbd;
  font-weight: 600;
`;

const ConfirmButton = styled.button`
  width: 100%;
  background-color: #003fbd;
  color: white;
  border: none;
  border-radius: 12px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
  font-size: 18px;
  line-height: 28px;
  letter-spacing: -0.2px;
  font-weight: 600;
`;

export const showCeoReportModal = () => {
  const modalContent = (
    <div>
      <ModalHeader>
        <CloseButton onClick={() => Modal()}>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5 5L19 19M19 5L5 19"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        </CloseButton>
        <HeaderContent>
          <ServiceTag>서비스 리뉴얼 안내</ServiceTag>
          <HeaderTitle>
            2025년 7월,
            <br />
            더욱 강력해진
            <br />
            CEO 리포트로 돌아왔습니다!
          </HeaderTitle>
          <img src={BackgroundImg} alt="" />
        </HeaderContent>
      </ModalHeader>
      <ModalContent>
        <ContentText>
          지금 바로 새로워진 CEO 리포트를 경험해보세요! <br />
          <HighlightText>
            여러분의 성공을 위해, 저희는 항상 앞서 나가겠습니다.
          </HighlightText>
        </ContentText>
        <ConfirmButton onClick={() => Modal()}>확인</ConfirmButton>
      </ModalContent>
    </div>
  );

  Modal(modalContent, false);
};
